import React from 'react'
import styled from 'styled-components'
import { Col, Container, Row } from 'react-bootstrap'
import { Box, MainHeading } from '../../../ui/Elements'
import { ContactButton, OffersBox } from '../../../ui/CustomElements'
import { useTranslation } from 'react-i18next'
import WhyChoose from '../whyChoose/WhyChoose'

const Offers = () => {
    const { t } = useTranslation()
    const WhatsApp = () => {
        const phoneNumber = '+966535316584';
        const whatsappURL = `https://wa.me/${phoneNumber}`;
        window.open(whatsappURL, '_blank');
    };
    return (
        <OffersWrapper className='container-fluid common-space servicesFluid' id='offers'>
            <Container>
                <Box className='d-flex flex-column align-items-center justify-content-center text-center my-3 main-heading'>
                    <MainHeading className='py-2 main-text'>{t('Irresistibleoffers')}</MainHeading>
                </Box>
                <Row className='offersRow'>
                    
                    <Col lg={6}>
                        <Row className='planRow'>
                            <Col lg={6} className='planCol planCol1'>
                                <OffersBox className="planIndonesia" city={t('Indonesia')} desc={t('tripIndonesia')} price="4500" />
                                <OffersBox className="planMalaysia" city={t('Malaysia')} desc={t('tripMalaysia')} price="3500" />
                                <OffersBox className="planAzerbaijan" city={t('Azerbaijan')} desc={t('tripAzerbaijan')} price="2500" />
                            </Col>
                            <Col lg={6} className='planCol planCol2'>
                                <OffersBox className="planTurkey" city={t('NorthernTurkey')} desc={t('tripTurkey')} price="2800" />
                                <OffersBox className="planGeorgia" city={t('Georgia')} desc={t('tripGeorgia')} price="2800" />
                                <OffersBox className="planMoscow" city={t('Moscow')} desc={t('tripMoscow')} price="4700" />
                            </Col>
                        </Row>
                    </Col>
                    <Col lg={6} className='pb-3'>
                        <Box className='offerBanner offerBanner1' onClick={WhatsApp}>
                            <Box className='offerContentContainer'>
                                <Box className="offerHeading">{t('Discoverwinter')}</Box>
                                <Box className="offerText">{t('Bookdream')}</Box>
                                <ContactButton label={t('BookNow')} padding='5px 15px' onClick={WhatsApp} />
                            </Box>
                        </Box>
                        <Box className='offerBanner offerBanner2' onClick={WhatsApp}>
                            <Box className='offerContentContainer'>
                                <Box className="offerHeading">{t('Yourdreamvacation')}</Box>
                                <Box className="offerText">{t('Dontmissoffer')}</Box>
                                <ContactButton label={t('BookNow')} padding='5px 15px' onClick={WhatsApp} />
                            </Box>
                        </Box>
                    </Col>
                </Row>
                <WhyChoose />
            </Container>
        </OffersWrapper>

    )
}
const OffersWrapper = styled.section`
    
`

export default Offers
